<h2 mat-dialog-title class="popup-title"><mat-icon>fact_check</mat-icon>{{ log.validated ? 'Remove validation' : 'Validate log' }}</h2>
<div mat-dialog-content class="popup-content">
  <p class="popup-description">{{ log.validated ? 'Remove validation from this manufacturing log.' : 'Confirm the device serial before validating this manufacturing log.' }}</p>
  <div class="popup-record"><span>Cub</span><strong>{{ log.sequenceNumber || log.serial }}</strong></div>
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Device serial</mat-label><input matInput [(ngModel)]="input" required>
  </mat-form-field>
</div>
<div mat-dialog-actions class="popup-actions">
  <button mat-stroked-button (click)="onNoClick()">Cancel</button>
  @if (log.validated) {
    <button mat-flat-button class="popup-danger" [disabled]="!input?.trim()" (click)="unValidateScout(log, true)">Remove validation</button>
  } @else {
    <button mat-flat-button class="popup-primary" [disabled]="!input?.trim()" (click)="validateScout(log, true)">Validate log</button>
  }
</div>
